import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import {Form144Issuer} from "./custom-interface/issuer-form144.model";


@Injectable({
  providedIn: 'root'
})
export class Form144Service {
  private readonly baseUrl = environment.form144ApiUrl;

  constructor(private http: HttpClient) {}

  getIssuersByName(name: string): Observable<Form144Issuer[]> {
    return this.http.get<Form144Issuer[]>(
      `${this.baseUrl}/issuerAffiliateRelationshipMaping/issuers?issuerName=${encodeURIComponent(name)}`
    );
  }
}
